const WHATSAPP = "@polyonpeps";
const WA_LINK = "https://wa.me/?text=Hi%20%40polyonpeps%2C%20I%27d%20like%20to%20ask%20about%20product%20availability%20%2F%20sourcing.";

function WhatsAppIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.548 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  );
}

export default function Footer() {
  return (
    <footer id="lab" className="border-t border-white/10 bg-[#050507] py-16 mt-10">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-4 gap-10">
        <div>
          <p className="tatau-text font-display font-black text-4xl md:text-5xl tracking-tighter leading-none">POLYON//PEPS</p>
          <p className="text-slate-500 font-mono2 text-xs mt-4 max-w-xs leading-relaxed">
            Precision research peptides. Lab-verified, cold-chain shipped. For laboratory research use only.
          </p>
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-widest text-[#00F0FF] font-mono2 mb-4">Payment &amp; Shipping</p>
          <p className="text-slate-400 font-mono2 text-xs">PayID: prosperouspoly@gmail.com</p>
          <p className="text-slate-500 font-mono2 text-[11px] mt-2">Add to cart → checkout → pay via PayID to confirm.</p>
          <p className="text-slate-500 font-mono2 text-[11px] mt-2">Express postage AUD $15 — Australia-wide.</p>
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-widest text-[#00F0FF] font-mono2 mb-4">Availability &amp; Sourcing</p>
          <a
            href={WA_LINK} target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-2 border border-[#25D366]/50 text-[#25D366] px-3 py-2 text-xs font-mono2 hover:bg-[#25D366] hover:text-black transition-colors"
            data-testid="footer-whatsapp-link"
          >
            <WhatsAppIcon size={15} /> WhatsApp {WHATSAPP}
          </a>
          <p className="text-slate-500 font-mono2 text-[11px] mt-3 leading-relaxed">Message us on WhatsApp to check stock or request a custom sourcing quote.</p>
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-widest text-[#00F0FF] font-mono2 mb-4">Compliance</p>
          <p className="text-slate-500 font-mono2 text-[11px] leading-relaxed">
            All products are sold strictly for in-vitro research and laboratory experimentation. Not for human or veterinary use.
          </p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-10 mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-2">
        <p className="text-slate-600 font-mono2 text-[11px]">© {new Date().getFullYear()} polyonpeps.com — All rights reserved.</p>
        <a href="/admin" className="text-slate-600 hover:text-[#00F0FF] font-mono2 text-[11px] transition-colors" data-testid="footer-admin-link">Admin</a>
      </div>
    </footer>
  );
}

export { WhatsAppIcon, WA_LINK, WHATSAPP };
